import { useMemo } from 'react';

export const useHideFields = (hideFieldsString) => {
  return useMemo(() => {
    try {
      return JSON.parse(hideFieldsString);
    } catch (error) {
      console.error('Error parsing hideFields:', error);
      return {};
    }
  }, [hideFieldsString]);
};